module.exports = __webpack_public_path__ + "img/春节大促_08.7268ac9f.png";